import { createShell } from '../../shell/createShell';
import { route } from './pages/registerPage';
import { RegisterFunnel } from '.';
const routes = [route];
export const registerShell = createShell(RegisterFunnel, {
  options: {
    routes,
    namespace: 'register_shell'
  }
});